import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, StatusBadge, EmptyState, MetricCard } from "@/components/lux";
import { money } from "@/lib/api";
import { UsersRound } from "lucide-react";

export default function Team() {
  const { data, loading } = useFetch("/user/team");
  const c = data?.counts;
  return (
    <div className="space-y-6">
      <PageTitle title="My Team" subtitle="Your full downline across both legs" />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <MetricCard label="Total Team" value={c?.total ?? "—"} icon={UsersRound} accent />
        <MetricCard label="Active" value={c?.active ?? "—"} icon={UsersRound} />
        <MetricCard label="Left Leg" value={c?.left ?? "—"} icon={UsersRound} />
        <MetricCard label="Right Leg" value={c?.right ?? "—"} icon={UsersRound} />
      </div>
      <GlassCard className="p-6">
        {loading ? <div className="skeleton h-40" /> : data?.members?.length ? (
          <div className="max-h-[32rem] overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-[var(--bg-2)] text-left text-[var(--text-dim)]"><tr className="border-b border-white/10">
                <th className="py-3">Member ID</th><th className="py-3">Name</th><th className="py-3">Leg</th><th className="py-3">Package</th><th className="py-3">Rank</th><th className="py-3">Status</th></tr></thead>
              <tbody>
                {data.members.map((m, i) => (
                  <tr key={i} className="row-hover border-b border-white/5">
                    <td className="py-3 text-white">{m.member_id}</td><td className="py-3">{m.name}</td>
                    <td className="py-3 capitalize">{m.leg}</td><td className="py-3 gold-text">${money(m.package)}</td>
                    <td className="py-3">{m.rank}</td><td className="py-3"><StatusBadge status={m.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={UsersRound} title="Your team is empty" hint="Members placed under you will appear here." />}
      </GlassCard>
    </div>
  );
}
